import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";
const initialState = {
  value: [],
  loading: false
};

export const addLabs = createAsyncThunk(
  "labs/addLabs",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.addLabs(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const addLabsSlice = createSlice({
  name: "addLabs",
  initialState,
  reducers: {
    clearAddLabResponse(state, action) {
      state.value = {}
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addLabs.pending, (state) => {
        state.loading = true;
      })
      .addCase(addLabs.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
        state.days = action.payload.days;
      })
      .addCase(addLabs.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const addLabsList = (state) => state.addLabs.value;
export const {clearAddLabResponse} = addLabsSlice.actions;
export default addLabsSlice.reducer;
